import { render, staticRenderFns } from "./DeleteMaterialTarget.vue?vue&type=template&id=79bb1d18&scoped=true&"
import script from "./DeleteMaterialTarget.vue?vue&type=script&lang=js&"
export * from "./DeleteMaterialTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb1d18",
  null
  
)

export default component.exports